import React from 'react'
import Currency from '../../../components/Currency'
import CaselessDetailPrice from '../components/CaselessDetailPrice'

const CaselessInvoiceSummary = ({ bill }) => {
  const { line_items, total } = bill

  return (
    <div className="mb-4">
      <div className="font-bold my-2">Invoice:</div>
      <div>
        {line_items.map(({ amount, description }, index) => {
          return (
            <div key={index} className="flex justify-between">
              <div>{description}</div>
              <div>
                <Currency amount={amount} />
              </div>
            </div>
          )
        })}
        <div className="flex justify-between my-2">
          <div>-</div>
          <div>-</div>
        </div>
        <CaselessDetailPrice total={total} />
      </div>
    </div>
  )
}

export default CaselessInvoiceSummary
